import React from "react";
import { IProgramRolesDisplay } from "@interfaces/Components";
import * as ProgramUtils from "@utils/programUtils";
import "../../theme/tailwind.css";
import { PROGRAM_IDS } from "@constants/programs";

const ProgramRolesDisplay: React.FC<IProgramRolesDisplay> = (props) => {
  if (props.programId === PROGRAM_IDS.LAS_NQP) {
    return null;
  }

  const usePrimaryLabel = ProgramUtils.showPrimaryLabelInProgramRolesDisplay(props.programId);
  const rolesLabel =
    props.userRoles.length === 1
      ? usePrimaryLabel
        ? "Your primary role"
        : "Your role"
      : usePrimaryLabel
        ? "Your primary roles"
        : "Your roles";

  return (
    <div className="mt-[8px] mb-[4px]">
      <div className="text-acc-13px leading-[1.54] tracking-[-0.1px] text-grey-70">
        {rolesLabel}
      </div>
      <div className="text-acc-17px leading-[1.53] tracking-[-0.3px] text-grey-90">
        {props.userRoles.length > 0 ? props.userRoles.sort().join(", ") : "None"}
      </div>
      {props.secondaryRoles && props.secondaryRoles.length > 0 && (
        <>
          <div className="mt-[8px] text-acc-13px leading-[1.54] tracking-[-0.1px] text-grey-70">
            {props.secondaryRoles.length === 1 ? "Your secondary role" : "Your secondary roles"}
          </div>
          <div className="text-acc-17px leading-[1.53] tracking-[-0.3px] text-grey-90">
            {props.secondaryRoles.sort().join(", ")}
          </div>
        </>
      )}
    </div>
  );
};

export default ProgramRolesDisplay;
